import { render } from "./Import_Mpesa_Txns.vue?vue&type=template&id=1fc14f30"
import script from "./Import_Mpesa_Txns.vue?vue&type=script&lang=js"
export * from "./Import_Mpesa_Txns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__